import { motion } from "framer-motion";
import { scrollToSection } from "@/lib/lenis";

const HERO_IMAGE =
  "https://images.unsplash.com/photo-1652677692579-473ce3444388?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzV8MHwxfHNlYXJjaHw0fHx3YWlrYXRvJTIwcml2ZXIlMjBmYXJtbGFuZCUyMG5ldyUyMHplYWxhbmQlMjBsYW5kc2NhcGUlMjBzdW5zZXQlMjBtaXN0eSUyMGdyZWVuJTIwaGlsbHN8ZW58MHx8fHwxNzkxMDY5MzczfDA&ixlib=rb-4.1.0&q=85";

export default function Hero() {
  return (
    <section id="hero" data-testid="hero-section" className="relative min-h-[85vh] flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src={HERO_IMAGE}
          alt="Waikato river valley, New Zealand"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-[#12344E]/70" />
        <div className="absolute inset-0 bg-gradient-to-r from-[#12344E]/80 via-[#12344E]/40 to-transparent" />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto w-full px-6 lg:px-10 pt-28 pb-20">
        <motion.h1
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.1 }}
          className="text-4xl sm:text-5xl lg:text-6xl font-bold leading-[1.1] tracking-tight text-white max-w-3xl"
          data-testid="hero-headline"
        >
          Investing in Enterprise
        </motion.h1>
        <motion.p
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.25 }}
          className="mt-6 max-w-xl text-base text-white/85 leading-relaxed"
          data-testid="hero-subtext"
        >
          Jamsac Investments is a privately owned investment company building
          and managing a diversified portfolio of property, businesses and
          strategic investments across New Zealand and Australia.
        </motion.p>
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.4 }}
          className="mt-9 flex flex-wrap items-center gap-4"
        >
          <button
            data-testid="hero-cta-explore"
            onClick={() => scrollToSection("#sectors")}
            className="px-8 py-3.5 rounded-full bg-[#1F6191] text-white text-xs font-bold uppercase tracking-[0.12em] hover:bg-[#2E7CB8] transition-colors duration-300"
          >
            View Our Portfolio
          </button>
          <button
            data-testid="hero-cta-thesis"
            onClick={() => scrollToSection("#about")}
            className="px-8 py-3.5 rounded-full border border-white/60 text-white text-xs font-bold uppercase tracking-[0.12em] hover:bg-white hover:text-[#12344E] transition-colors duration-300"
          >
            About Jamsac
          </button>
        </motion.div>
      </div>
    </section>
  );
}
